export const typeArray = ["Practice", "Simulation"];
